// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const Orgashwin = {
  productCode: "SBOVZ-Orgashwin",
  productName: "Orgashwin",
  ingredients: "Withania somnifera",
  overview:"Orgashwin is a broad spectrum aswagandha extract balanced with pepper greens extract standardized for melatonin traces. The ingredient is certified organic and a clinical ingredient for sleep, stress and adaptogenic properties. The ingredient is produced from our pure line selection and manufactured with our proprietary technology.",
  assay:"Withanolides 3.25%",
  coNutrients:"",
  studies:"",
  benefits:" Helps glucose and lipid balance, reduce fat deposition in adipocytes. Improves stress induced oxidation, glucose dependent insulin secretion, blood glucose metabolism. Ashwagandha extract reduces the symptoms of physiological anxiety, ADHD and comorbid anxiety disorders, helps improve serum cortisol, body weight, and BMI. Higher Oxford Happiness Questionnaire (OHQ) scores indicate lower stress levels and significantly better psychological well-being and sleep quality.",
  functionalUse: {
    main: "💊︎ Capsule",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForRegenerativeHealth/Orgashwin.png"
    

  ],
  certificates: [
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",
  ]
};

export default Orgashwin;
